// extracted by mini-css-extract-plugin
module.exports = {"container":"S0LFB8xI","iconContainer":"_2iJZ4Uhd","textContainer":"c9xFbFtc","linkButtonContent":"X_jpX9ck"};